import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Company } from '../../shared/models/companies/company.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CompanyService {
  private baseUrl = environment.baseUrl + 'v2.0/companies/';

  constructor(private http: HttpClient) {
  }

  public getCompanies = () => this.http.get<Company[]>(this.baseUrl);
}
